<template>
    <div class="input_memo_box">
        <el-input type="textarea" resize="none" v-model="memo"
                  placeholder="내용을 입력하세요." @input="parentChange('memo', memo)"></el-input>
        <div class="input_error" v-if="validation.hasError('memo')">{{validation.firstError('memo') }}</div>
    </div>
</template>

<script>
import orderValidator from "../../orderValidator";
import util from "../../../../mixins/util";
import EventBus from "../../../../mixins/event-bus";
export default {
    name: "OrderWriteMemoLayout",
    mixins: [orderValidator],
    components: {},
    inject: ['orderWriteSetData'],
    provide() {
        return {}
    },
    props: {
        orderTitle : '',
        memo : '',
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
        // this.initSetData();
    },
    mounted() {
        EventBus.$on('OrderWriteMemoLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('OrderWriteMemoLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        // initSetData(){
        //     if(!util.isEmpty(this.orderData)){
        //         this.memo = this.orderData.memo
        //     }
        // },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        parentChange(key, value) {
            if (!util.isEmpty(this.orderWriteSetData) && util.isFunction(this.orderWriteSetData)) {
                this.orderWriteSetData(key, value);
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>